module.exports = __webpack_public_path__ + "img/4a_indentity-management.68720482.png";